//@flow

import {useMemo} from 'react';
import {useCategories} from '../../categories/utils';
import {useStorePromotions} from '../../marketing/promotions/utils';
import {useStoreDomain} from '../../store/utils';
import {getImageUrl} from '../../../utils/image_provider';
import {useSearchMinimalProducts} from '../../products/utils/hooks';
import {GENERIC_STOREFRONT_PAGES} from '../constants/store-pages';

type UrlInputOption = {
  name: string,
  id: string,
  thumbnail?: string,
  url: string,
  typeLabel: string,
  type: string,
};

export function useLinkResourceOptions() {
  const categories = useCategories();
  const promotions = useStorePromotions();
  const {domain} = useStoreDomain();
  const {loading, products, searchProductsByName} = useSearchMinimalProducts({
    initialList: true,
  });

  const categoryOption: UrlInputOption[] = useMemo(
    () =>
      categories.map(category => ({
        name: category.name,
        id: category.id,
        thumbnail: getImageUrl(category.portraitImageId),
        url: `https://${domain && domain.domainName}/category/${category.id}`,
        typeLabel: 'Categorías',
        type: 'CATEGORY',
      })),
    [categories, domain]
  );

  const promotionOption: UrlInputOption[] = useMemo(
    () =>
      promotions.map(promotion => ({
        name: promotion.name,
        id: `${promotion.slug}`,
        thumbnail: getImageUrl(promotion.promotionImageId),
        url: `https://${domain && domain.domainName}/promo/${promotion.slug}`,
        typeLabel: 'Promociones',
        type: 'PROMOTION',
      })),
    [domain, promotions]
  );

  const productOption: UrlInputOption[] = useMemo(
    () =>
      products.map(product => ({
        name: product.name,
        id: product.id,
        thumbnail: getImageUrl(product.mainImageId),
        url: `https://${domain && domain.domainName}/product/${product.id}`,
        typeLabel: 'Productos',
        type: 'PRODUCT',
      })),
    [domain, products]
  );

  const genericPagesOption: UrlInputOption[] = useMemo(
    () =>
      GENERIC_STOREFRONT_PAGES.map(page => ({
        name: page.label,
        id: page.path,
        url: `https://${domain && domain.domainName}${page.path}`,
        typeLabel: 'Páginas genéricas',
        type: 'URL',
      })),
    [domain]
  );

  return {
    categoryOption,
    promotionOption,
    productOption,
    genericPagesOption,
    searchProductsByName,
    loading,
  };
}
